import ko from 'knockout';
import _ from 'underscore';
import DataStore from '@bingads-webui-component-legacy/js-data-campaign/index';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';
import itemTemplate from '@bingads-webui-campaign-legacy/auto-targets/template/pagefeed/feed-preview.pug';
import instrumentation from '@bingads-webui-static-legacy/instrumentation/index';
import constants from '@bingads-webui-static-legacy/instrumentation/constants';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/auto-targets');

export default class ViewModel {
  constructor({
    source,
    campaignId,
    loadSource,
  }) {
    this.radioList =  [{
      value: 'SystemIndex',
      text: i18n.get('Campaign_TargetingSource_Bing_Index'),
    }, {
      value: 'AdvertiserSuppliedUrls',
      text: i18n.get('Campaign_TargetingSource_Page_Feed'),
    }, {
      value: 'All',
      text: i18n.get('Campaign_TargetingSource_Both_Index_Feed'),
    }];
    this.originSelectedFeeds = ko.observableArray([]);
    this.source = ko.observable(source || this.radioList[0].value);
    this.selectedFeeds = ko.observableArray([]);
    this.allFeeds = loadSource;
    this.itemTemplate = itemTemplate;
    this.showPagefeedSelector = ko.computed(() => _.contains(['AdvertiserSuppliedUrls', 'All'], this.source()));

    this.campaignId = ko.observable(campaignId);
    this.targetingSource = ko.computed(() => ({
      source: this.source(),
      selectedFeeds: this.selectedFeeds(),
    }));
    this.updateSelectedFeedsByCampaignId(this.campaignId(), true);
    this.campaignId.subscribe((newCampaignId) => this.updateSelectedFeedsByCampaignId(newCampaignId));
    this.associateList = ko.computed(() => {
      const originList = _.pluck(this.originSelectedFeeds(), 'Id');
      const selectedList = _.pluck(this.selectedFeeds(), 'Id');

      return _.difference(selectedList, originList);
    });

    this.originSelectedIdList = ko.computed(() => _.pluck(this.originSelectedFeeds(), 'Id'));
    this.selectedIdList = ko.computed(() => _.pluck(this.selectedFeeds(), 'Id'));

    this.errors = ko.computed(() => {
      const ret = [];

      if (this.source() !== 'SystemIndex' && _.size(this.selectedFeeds()) === 0 ) {
        ret.push(i18n.get('Campaign_TargetingSource_Page_Select_At_Least_One'));
      }
      return ret;
    });
  }

  updateSelectedFeedsByCampaignId(campaignId, isEditing = false) {
    if (campaignId) {
      // load associated page feeds
      DataStore.FeedAssociation.findAll({
        skip: 0,
        limit: 100,
      }, {
        entitySet: edmCampaign.currentAccount.Campaigns.$withKey(campaignId).FeedAssociations,
        cacheResponse: false,
        'x-ms-refreshcampaigncache': 'true',
      }).then((values) => {
        instrumentation.logMessage([
          constants.LOGCATEGORY.TRACE], constants.LOGLEVEL.INFO,
        'GetFeedAssociation',
        '1');
        const items = _.map(values, (val) => ({ Id: val.FeedId, Name: val.FeedName }));

        this.selectedFeeds(items);
        if (isEditing) {
          this.originSelectedFeeds(items);
        }
      }).catch((e) => {
        instrumentation.logMessage([
          constants.LOGCATEGORY.ERROR], constants.LOGLEVEL.VERBOSE,
        'GetFeedAssociation',
        e);
        return null;
      });
    }
  }
}
